import ProductCard from '@/components/reusable/productCard/ProductCard';
import { ProductListRecord } from '@/components/reusable/productCard/types';
import Carousel from '@/components/reusable/carousel/Carousel';
import { SplideSlide } from '@splidejs/react-splide';
import { FC } from 'react';
import { carouselSettings } from './constants';
interface HousesCarouselComponentProps {
  list: ProductListRecord[];
  lateNight?: boolean;
}
const HousesCarouselComponent: FC<HousesCarouselComponentProps> = ({
  list,
  lateNight
}) => {
  return <Carousel opts={carouselSettings} data-sentry-element="Carousel" data-sentry-component="HousesCarouselComponent" data-sentry-source-file="HousesCarouselComponent.tsx">
      {list?.map((item, index) => <SplideSlide key={`houses-${item?.id}`}>
          <ProductCard lateNight={lateNight} key={item.id} data={item} index={index} isCarousel />
        </SplideSlide>)}
    </Carousel>;
};
export default HousesCarouselComponent;